var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status != 'null')?_c('div',{},[_c('p',{staticClass:"w-8 h-8 flex opacity-li5 items-center justify-center main font-semibold rounded-full border-dark text-dark",attrs:{"title":_vm.status}},[_vm._v("\n    "+_vm._s(_vm.status.charAt(0))+"\n    "+_vm._s([..._vm.status.substring(_vm.status.indexOf(" ") + 1)][0])+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }